import styled from 'styled-components';
import { Offcanvas } from 'react-bootstrap';
import HeadingOutline1 from '../assets/svg/HeadingOutline1';
import { useState, useMemo } from 'react';
import './style.scss';
import { useGetPreviewThemesLinkQuery } from '../publicPagesProdApiSlice';
import { Carousel } from 'react-bootstrap';

const Wrapper = styled.section`
  background: var(--BG-Color, #f2f2f2);

  .container {
    max-width: 1440px;
    padding: 6.25rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  h2 {
    color: var(--font-color-font-1, #1b131f);
    font-family: Instrument Sans;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: 88px;
    text-align: center;
  }

  p {
    color: var(--font-color-font-1, #1b131f);
    text-align: center;
    font-family: Instrument Sans;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }

  .outline-container {
    position: relative;
    padding: 0 5px;

    .outline {
      position: absolute;
      top: -7px;
      left: 0;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .img-container {
    margin: 48px 0;
    display: flex;
    justify-content: center;
    gap: 2rem;
    align-items: stretch;

    :first-child {
      margin-bottom: 24px;
    }

    :last-child {
      margin-top: 24px;
    }

    .img-item {
      position: relative;
      width: 100%;
      overflow: hidden;
      flex: 1;

      &:first-child,
      &:last-child {
        flex: 3;
      }

      .eye-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.5s ease-in-out;
        opacity: 0;
      }

      img {
        height: 100%;
        object-fit: cover;
        transition: all 0.5s ease-in-out;
        filter: brightness(1);
        cursor: pointer;
      }

      &:hover {
        img {
          filter: brightness(0.4);
        }

        .eye-icon {
          opacity: 1;
        }
      }
    }
  }

  .action-button {
    display: flex;
    padding: 19px 30px 19px 36px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    border: 2px solid var(--primary-primary-600-f, #62aa48);
    background: var(--primary-primary-600-f, #62aa48);
    color: var(--font-color-font-4, #fff);
    text-align: center;

    font-family: Instrument Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
  }

  img {
    min-height: 450px;
  }

  @media screen and (max-width: 1024px) {
    h2 {
      font-size: 45px;
      line-height: 58px;
    }

    p {
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
    }

    .img-container {
      margin: 1.5rem 0;
      display: flex;
      justify-content: center;
      gap: 2rem;

      :first-child {
        margin-bottom: 1.5rem;
      }

      :last-child {
        margin-top: 1.5rem;
      }
    }

    .action-button {
      display: flex;
      padding: 16px 32px 16px 32px;
    }
  }

  @media screen and (max-width: 768px) {
    img {
      min-height: 330px;
    }

    .container {
      padding: 2rem 1.25rem;
    }

    h2 {
      font-size: 32px;
      line-height: 40px;
    }

    p {
      font-size: 16px;
      line-height: 24px;
    }

    .outline-container {
      position: relative;
      padding: 0 5px;

      .outline {
        display: none;
        position: absolute;
        top: -7px;
        left: 0;

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .img-container {
      margin: 48px 0;
      display: flex;
      flex-direction: column;
      gap: 48px;

      :first-child {
        margin-bottom: 24px;
      }

      :last-child {
        margin-top: 24px;
      }
    }

    .action-button {
      padding: 14px 16px;
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media screen and (max-width: 425px) {
    img {
      min-height: 125px;
    }
  }
  @media screen and (max-width: 991px) {
    .mobile-hide-slider {
      display: none !important;
    }
  }
  @media screen and (min-width: 992px) {
    .mobile-show-slider {
      display: none !important;
    }
  }
`;

const ImageCarousel = ({ images, name, onPreviewClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div className="image-container">
      <Carousel
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        controls={hovered ? true : false}
      >
        {images.map((image) => (
          <Carousel.Item>
            <img
              src={image?.url}
              className="images"
              alt={image?.altText}
              draggable={false}
            />
          </Carousel.Item>
        ))}
      </Carousel>

      <div className="image-text">
        <span
          style={{
            fontSize: '17px',
          }}
        >
          {name}
        </span>
        <span
          onClick={onPreviewClick}
          style={{
            gap: '2px',
            display: 'flex',
            alignItems: 'center',
            fontSize: '17px',
            cursor: 'pointer',
            color: '#4c0e6b',
          }}
        >
          <i className="fa fa-eye" aria-hidden="true" />
          Preview
        </span>
      </div>
    </div>
  );
};

const Templates = () => {
  const [openThemePreview, setOpenThemePreview] = useState(null);
  const { data } = useGetPreviewThemesLinkQuery();

  const filteredData = data?.slice(0, 13);
  const CrousalImages = [
    {
      id: 19,
      name: 'The Floral Exchange',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/theFloralExhangeDesktop-292105-1722487011750.png',
          altText: 'beautiful floral website templates and themes',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/floralExchangeMobile-1232981-1722487011750.png',
          altText: 'customizable florist website templates',
        },
      ],
    },
    {
      id: 20,
      name: 'The Blossom Hub',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/blossomhubDesktop-253180-1722487819960.png',
          altText: 'flower shop website template',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/blossomHubMobile-1049774-1722487819959.png',
          altText: 'floral website template',
        },
      ],
    },
    {
      id: 34,
      name: 'The FloraFusion',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/florafusionMobile-1129557-1722487297278.png',
          altText: 'best flower shop website template',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/floraFusionDesktop-258655-1722487297277.png',
          altText: 'best floral website template',
        },
      ],
    },
    {
      id: 268,
      name: 'The Sweet Stems',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/sweetstemsDesktop-339547-1722486726163.png',
          altText:
            'great looking florist website template options for your site',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/sweetStemMobile-970176-1722486726164.png',
          altText: 'florist website template options',
        },
      ],
    },
    {
      id: 269,
      name: 'The Engima Florist',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/enigmaFloristDesktop-312115-1722487409443.png',
          altText: 'Florist and Flower Shop website templates',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/enigmafloristMobile-908091-1722487409442.png',
          altText: 'best flower shop website template',
        },
      ],
    },
    {
      id: 304,
      name: 'The Meadow Muse',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/meadowmuseDesktop-467673-1722486845102.png',
          altText: 'beautiful floral website templates and themes',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/meadowmuseMobile-1191662-1722486845101.png',
          altText:
            'great looking florist website template options for your site',
        },
      ],
    },
    {
      id: 369,
      name: 'Blooming Bliss',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/bloomingBlissDesktop-197912-1722488441024.png',
          altText: 'best flower shop website template',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/bloomingBlisMobile-1059798-1722488441025.png',
          altText: 'beautiful floral website templates and themes',
        },
      ],
    },
    {
      id: 372,
      name: 'Enchanted Garden',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/enchantedgardenDesktop-562890-1722488246856.png',
          altText:
            'great looking florist website template options for your site',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/enchantedGardenMobile-1272106-1722488246855.png',
          altText: 'best floral website template',
        },
      ],
    },
    {
      id: 373,
      name: 'Garden Glowery',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/gardenGloweryDesktop-317393-1722488156758.png',
          altText:
            'great looking florist website template options for your site',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/gardenGloweryMobile-1190035-1722488156757.png',
          altText: 'customizable florist website templates',
        },
      ],
    },
    {
      id: 374,
      name: 'Velvet Patel',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/velvetpatelDesktop-569669-1722486491406.png',
          altText: 'best flower shop website template',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/velvetPatelMobile-1193018-1722486491405.png',
          altText:
            'great looking florist website template options for your site',
        },
      ],
    },
    {
      id: 375,
      name: 'Bouquet Vault',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/bouquetVaultDesktop-249299-1722488324716.png',
          altText: 'best floral website template',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/bouquetVaultMobile-1060208-1722488324715.png',
          altText: 'customizable florist website templates',
        },
      ],
    },
    {
      id: 407,
      name: 'Petal Central',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/Petraldesktop-1092962-1726817300721.png',
          altText: 'customizable florist website templates',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/PetralMobile-1476636-1726817717182.png',
          altText: 'best floral website template',
        },
      ],
    },
    {
      id: 439,
      name: 'Flora Union',
      images: [
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/Flora union2 desktop-852296-1726817040811.png',
          altText:
            'great looking florist website template options for your site',
        },
        {
          url: 'https://thumbnails.dev.boostfloral.com/image-gallery/FloraUnionMobile-1106923-1726816782154.png',
          altText: 'flower shop website template',
        },
      ],
    },
  ];

  // function to get the redirect URL based on the template ID.
  const memoizedGetRedirectUrl = useMemo(() => {
    return (templateId) => {
      if (!filteredData?.length) return null;

      const selected = filteredData.find(
        (theme) => theme?.templateId === templateId,
      );
      if (selected) return selected?.redirectUrl;

      return filteredData[0]?.redirectUrl;
    };
  }, [filteredData]);

  return (
    <Wrapper>
      <div className="container" style={{ overflow: 'visible' }}>
        <h2>
        Choose from beautiful Floral Website{' '}
          <span className="outline-container">
            themes
            <span className="outline">
              <HeadingOutline1 />
            </span>
          </span>
        </h2>
        <p>Beautiful Flower Shop Websites</p>
        <div
          style={{ width: '90%', maxWidth: '90%' }}
          className="Template-Data"
        >
          {filteredData?.length > 0 &&
            filteredData.map((subGroup) => {
              const imageArray = CrousalImages.find(
                (item) => item.id === subGroup.id,
              )?.images || [subGroup.imageUrl];
              return (
                <ImageCarousel
                  key={subGroup.id}
                  images={imageArray}
                  name={subGroup.name}
                  onPreviewClick={() =>
                    setOpenThemePreview({
                      ...subGroup,
                      redirectUrl: memoizedGetRedirectUrl(subGroup.templateId),
                    })
                  }
                />
              );
            })}
        </div>
      </div>

      <Offcanvas
        show={openThemePreview ? true : false}
        onHide={() => setOpenThemePreview(null)}
        placement={'end'}
        className="w-75"
      >
        <Offcanvas.Header closeButton className="bg-white px-4">
          <Offcanvas.Title>{openThemePreview?.name}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="overflow-none">
          <iframe
            title="template"
            src={openThemePreview?.redirectUrl + '?disableCheckout=true'}
            className="w-100 h-100"
          />
        </Offcanvas.Body>
      </Offcanvas>
    </Wrapper>
  );
};

export default Templates;
